import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyFailsSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-187">
          Por qué las soluciones viejas fallan
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-188">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-189">
            <div className="flex justify-center mb-4" data-id="element-190">
              <XCircle className="h-12 w-12 text-red-500" data-id="element-191" />
            </div>
            <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-192">
              Las Dietas Extremas
            </h3>
            <p className="text-gray-600 text-center text-sm" data-id="element-193">
              Solo disparan el cortisol (la hormona del estrés), lo que
              paradójicamente sube el azúcar en sangre.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-194">
            <div className="flex justify-center mb-4" data-id="element-195">
              <XCircle className="h-12 w-12 text-red-500" data-id="element-196" />
            </div>
            <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-197">
              Los Fármacos
            </h3>
            <p className="text-gray-600 text-center text-sm" data-id="element-198">
              Tapan el síntoma mientras el páncreas se sigue apagando
              lentamente, creando dependencia.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-199">
            <div className="flex justify-center mb-4" data-id="element-200">
              <XCircle className="h-12 w-12 text-red-500" data-id="element-201" />
            </div>
            <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-202">
              Ejercicio Intenso
            </h3>
            <p className="text-gray-600 text-center text-sm" data-id="element-203">
              Nadie de 50 años quiere vivir en un gimnasio. Necesitamos
              soluciones realistas para nuestra vida.
            </p>
          </div>
        </div>
      </div>
    </section>;
}